'use strict';

module.exports = /*@ngInject*/
function(
    ApiConfig,
    InterceptorService
) {
    return {
	/**
         * Submits an http POST request to create a customer subscription
         * @param  {Object}     customer data
         */
        sendSubscription: function(data) {
            return InterceptorService.post(ApiConfig.customer.subscription, data);
        },
        /**
         * Submits an http PUT request to update an existing customer subscription
         * @param  {Object}     customer data
         */
        updateSubscription: function(data) {
            return InterceptorService.put(ApiConfig.customer.subscription, data);
        }
    };
};
